import { render, staticRenderFns } from "./Parzelle.vue?vue&type=template&id=3e78086b&"
import script from "./Parzelle.vue?vue&type=script&lang=js&"
export * from "./Parzelle.vue?vue&type=script&lang=js&"
import style0 from "./Parzelle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports